// loading overlay
const loadingOverlays = document.querySelectorAll('.js-loading-overlay');

if(!loadingOverlays);
loadingOverlays.forEach(element => {
  window.addEventListener("load", () => {
    element.setAttribute('aria-hidden', 'true');
  });
});
